import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Quality_Plan_Form.css";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/quality_control/Slice";
import {
  allVerificationType,
  AllParameter,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";

function Quality_Plan_Form({ onProceed }) {
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
    setError,
    clearErrors,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      parameters: [],
    },
  });

  const dispatch = useDispatch();

  const all_verification_type = useSelector(
    (state) => state.common.all_verification_type,
  );
  const all_parameter = useSelector((state) => state.common.all_parameter);

  useEffect(() => {
    dispatch(allVerificationType());
    dispatch(AllParameter());
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      clearErrors("parameters_error");

      // const filledParams = data.parameters?.filter((p) => p?.value?.trim());

      // if (!filledParams || filledParams.length === 0) {
      //   setError("parameters_error", {
      //     type: "manual",
      //     message: "At least one Acceptance Parameter value is required",
      //   });
      //   return;
      // }

      const payload = {
        frequency: data.frequency,
        type_of_verification_id: data.type_of_verification_id,
        parameters: data.parameters.map((item) => ({
          parameter_id: item.parameter_id,
          value: item.value,
        })),
        remark: data.remark,
      };

      const res = await dispatch(Create(payload));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset({
          frequency: "",
          type_of_verification_id: "",
          remark: "",
          parameters: all_parameter?.map((item) => ({
            parameter_id: item.value,
            value: "",
          })),
        });
        onProceed?.();
      }
    } catch (error) {
      console.error("Error creating Quality Control Plan:", error);
    }
  };
  useEffect(() => {
    all_parameter?.forEach((item, index) => {
      setValue(`parameters.${index}.parameter_id`, item.value);
    });
  }, [all_parameter, setValue]);

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        {/* ===== TOP ROW ===== */}
        <div className="row">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Type Of Verification</Form.Label>
              <Controller
                name="type_of_verification_id"
                control={control}
                rules={{ required: "Type Of Verification is required" }}
                render={({ field }) => (
                  <Select
                    options={all_verification_type}
                    value={
                      all_verification_type?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.type_of_verification_id && (
                <Form.Text className="text-danger">
                  {errors.type_of_verification_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Frequency</Form.Label>
              <Form.Control
                placeholder="Frequency"
                {...register("frequency", {
                  required: "Frequency is required",
                })}
              />
              {errors.frequency && (
                <Form.Text className="text-danger">
                  {errors.frequency.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        {/* ===== ACCEPTANCE PARAMETER CRITERIA ===== */}
        <div className="row mt-3">
          <div className="col-md-12">
            <Form.Label>Acceptance Parameter Criteria</Form.Label>
            {errors.parameters_error && (
              <Form.Text className="text-danger">
                {errors.parameters_error.message}
              </Form.Text>
            )}
          </div>

          {all_parameter?.map((item, index) => (
            <div
              className="col-xxl-2 col-xl-2 col-lg-3 col-md-3"
              key={item.value}
            >
              <div className="observation_box">
                <div className="obs_label">{item.label}</div>

                <div className="form_field_holder">
                  <Form.Control
                    placeholder={item.label}
                    {...register(`parameters.${index}.value`, {
                      required: "Value is required",
                    })}
                    // onKeyDown={(e) => {
                    //   const value = e.target.value;

                    //   // Allow control keys
                    //   if (
                    //     [
                    //       "Backspace",
                    //       "Delete",
                    //       "Tab",
                    //       "ArrowLeft",
                    //       "ArrowRight",
                    //     ].includes(e.key)
                    //   ) {
                    //     return;
                    //   }

                    //   // Allow numbers
                    //   if (/^[0-9]$/.test(e.key)) {
                    //     return;
                    //   }

                    //   // Allow ONE decimal point
                    //   if (e.key === "." && !value.includes(".")) {
                    //     return;
                    //   }

                    //   // Block everything else
                    //   e.preventDefault();
                    // }}
                  />
                  <input
                    type="hidden"
                    {...register(`parameters.${index}.parameter_id`)}
                    // defaultValue={item.value}
                  />

                  {errors.parameters?.[index]?.value && (
                    <small className="text-danger">
                      {errors.parameters[index].value.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== FOOTER BUTTONS ===== */}
        <div className="permission_btn_holder mt-4">
          <Button className="permission_btn No_btn" onClick={() => reset()}>
            Reset
          </Button>
          <Button
            type="button"
            className="permission_btn Yes_btn"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Quality_Plan_Form;
